import React, { useRef, useState } from 'react';

import './Hero.css';

interface HeroProps {
    backgroundImage?: string;
    backgroundVideo?: string;
    contentImage?: string;
    heading?: string;
    description?: string;
    type?: 'default' | 'boxed-text' | 'split';
}

const Hero: React.FC<HeroProps> = ({ backgroundImage, backgroundVideo, contentImage, heading, description, type = 'default' }) => {
    const videoRef = useRef<HTMLVideoElement>(null);
    const [isMuted, setIsMuted] = useState(true);
    const handleUnmute = () => {
        if (videoRef.current) {
            videoRef.current.muted = !videoRef.current.muted;
            setIsMuted(videoRef.current.muted);
        }
    };

    return (
        <section className={`section-heero section-heero--${type}`}>
            {
                (heading || description) &&
                <div className="section-heero__content">
                    <div className="section-heero__content-text">
                        {heading && <h1 className="section-heero__heading">{heading}</h1>}
                        {description && <div className="section-heero__description">{description}</div>}
                    </div>
                    {
                        contentImage && (
                            <div className="section-heero__content-media">
                                <img src={contentImage} alt={description} className="section-heero__content-image"/>
                            </div>
                        )
                    }
                </div>
            }
            {
                backgroundImage && (
                    <div className="section-heero__background-media">
                        <img src={backgroundImage} alt="background" className="section-heero__background-image"/>
                    </div>
                )
            }
            {
                backgroundVideo && (
                    <div className="section-heero__background-media">
                        <video
                            ref={videoRef}
                            autoPlay
                            muted={isMuted}
                            loop
                            playsInline
                            className="section-heero__background-video">
                            <source src={backgroundVideo} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                        <button className={`section-heero__unmute-video-button ${isMuted ? '' : 'section-heero__unmute-video-button--pushed'}`} onClick={handleUnmute} aria-label="Unmute video"></button>
                    </div>
                )
            }
        </section>
    );
};

export default Hero;